import { render, staticRenderFns } from "./SaveNotice.vue?vue&type=template&id=77584edb&scoped=true&"
import script from "./SaveNotice.vue?vue&type=script&lang=js&"
export * from "./SaveNotice.vue?vue&type=script&lang=js&"
import style0 from "./SaveNotice.vue?vue&type=style&index=0&id=77584edb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77584edb",
  null
  
)

export default component.exports